module.exports = __webpack_public_path__ + "img/grouped_bar.619257a4.svg";